import { render, staticRenderFns } from "./Webstore2.vue?vue&type=template&id=43b487e6&scoped=true"
import script from "./Webstore2.vue?vue&type=script&lang=js"
export * from "./Webstore2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b487e6",
  null
  
)

export default component.exports